import type {ReactElement} from 'react';

export enum StoryPreviewPlatform {
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
}

export interface StoryPreviewPlatformParts {
  avatarClassName: string;
  footerActions: ReactElement;
  headerActions: ReactElement | null;
}

export const FACEBOOK_STORY_FOOTER_ICON_PATHS: string[] = ['socialmedia/comment-icon-facebook-story.svg'];
export const FACEBOOK_STORY_ADD_ICON_PATH = 'socialmedia/add-icon-facebook-story.svg';

export const INSTAGRAM_STORY_FOOTER_ICON_PATHS: string[] = ['socialmedia/heart-icon-instagram-story.svg', 'socialmedia/share-icon-instagram-story.svg'];
